import { baseApi } from "../baseApi";

export const KuldeviApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // CREATE
    createKuldevi: builder.mutation({
      query: (data) => ({
        url: "/kuldevi-create",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
      invalidatesTags: ["Kuldevi"], // ✅ This will auto-refetch
    }),

    // GET ALL
    getKuldevi: builder.query({
      query: ({
        page = 1,
        limit = 10,
        search = "",
        status = "",
      } = {}) =>
        `/kuldevi-list?page=${page}&limit=${limit}&search=${search}&status=${status}`,
      providesTags: ["Kuldevi"], // ✅ This provides the tag
    }),

    // GET SINGLE
    getSingleKuldevi: builder.query({
      query: (id) => `/kuldevi-view/${id}`,
      providesTags: (result, error, id) => [{ type: "Kuldevi", id }],
    }),

    // UPDATE
    updateKuldevi: builder.mutation({
      query: (data) => ({
        url: "/kuldevi-update",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
      invalidatesTags: ["Kuldevi"], // ✅ This will auto-refetch
    }),

    // STATUS CHANGE
    changeStatusKuldevi: builder.mutation({
      query: (id) => ({
        url: `/kuldevi-status/${id}`,
        method: "GET",
      }),
      invalidatesTags: ["Kuldevi"], // ✅ This will auto-refetch
    }),

    // DELETE
    deleteKuldevi: builder.mutation({
      query: (id) => ({
        url: `/kuldevi-delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Kuldevi"], // ✅ This will auto-refetch
    }),
  }),
});

export const {
  useCreateKuldeviMutation,
  useGetKuldeviQuery,
  useGetSingleKuldeviQuery,
  useUpdateKuldeviMutation,
  useDeleteKuldeviMutation,
  useChangeStatusKuldeviMutation,
} = KuldeviApi;